import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';

import config from 'appConfig';
import { Layout, LoginForm, RegisterForm, useAuth } from 'lib/auth';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

const pageTitle = `${config.appName} - Login/Signup Page`;
function Login() {
  const router = useRouter();
  const { session, loading } = useAuth();

  useEffect(() => {
    if (session) {
      router.replace(router.query?.callbackUrl ?? '/');
    }
  }, [router, session]);

  if (loading || session) return null;

  return (
    <Layout
      pageTitle={pageTitle}
      content={
        <div className="form-tab">
          <Tabs selectedTabClassName="show" defaultIndex={0}>
            <TabList className="nav nav-pills nav-fill">
              <Tab className="nav-item">
                <span className="nav-link">Sign In</span>
              </Tab>
              <Tab className="nav-item">
                <span className="nav-link">Register</span>
              </Tab>
            </TabList>

            <div className="tab-content">
              <TabPanel>
                <div style={{ paddingTop: '2rem' }}>
                  <LoginForm />
                </div>
              </TabPanel>
              <TabPanel>
                <div style={{ paddingTop: '2rem' }}>
                  <RegisterForm />
                </div>
              </TabPanel>
            </div>
          </Tabs>
        </div>
      }
    />
  );
}

export default Login;
